"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTab = getMuiTab;
function getMuiTab() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '&.Mui-disabled': {
            color: theme.palette.gray[400],
            opacity: '1.0'
          },
          backgroundColor: 'transparent',
          color: theme.palette.gray[500],
          fontSize: theme.typography['text-sm-semibold'],
          minHeight: '0',
          opacity: '100%',
          padding: '8px 12px',
          textTransform: 'none'
        };
      }
    }
  };
}